export default __webpack_public_path__ + "static/media/Carrusel_06.9d3dd341.png";